var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "datetime-range-picker",
      class: { "datetime-range-picker-prepend": _vm.$slots.prepend },
    },
    [
      _vm._t("prepend"),
      _c(
        "el-date-picker",
        _vm._b(
          {
            staticClass: "datetime-range-picker-input",
            staticStyle: { width: "100%" },
            attrs: {
              slot: "reference",
              value: _vm.value,
              type: _vm.pickerType,
              "range-separator": _vm.rangeSeparatorText,
              "start-placeholder": _vm.startPlaceholderText,
              "end-placeholder": _vm.endPlaceholderText,
              format: _vm.pickerFormat,
              "value-format": _vm.pickerValueFormat,
              "default-time": _vm.defaultTime,
              "picker-options": _vm.pickerOptions,
              clearable: "",
            },
            on: { input: _vm.onInput },
            slot: "reference",
          },
          "el-date-picker",
          _vm.$attrs,
          false
        )
      ),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }